<template>
  <div>
    <card-layout :animation-delay="animationDelay" @go="go()">
      <h3 class="mb-smaller text text-truncate">
        {{ specName }}
      </h3>
      <p>врач</p>
      <div class="mb-small">
        <h3 class="h2 text-truncate card-doctor">
          {{ firstName }}
        </h3>
        <h3 class="h2 text-truncate card-doctor">
          {{ lastName }}
        </h3>
        <h3 class="h2 text-truncate card-doctor">
          {{ secondName }}
        </h3>
      </div>
      <p>дата посещения</p>
      <h4 class="h4 mb-small">{{ eventDate }}</h4>
      <p>время записи</p>
      <h4 class="h4">{{ eventTime }}</h4>
    </card-layout>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRouter } from "vue-router";
import CardLayout from "@/layouts/CardLayout";

export default {
  name: "EventCard.vue",
  props: {
    animationDelay: { type: Number, default: 0 },
    doctorName: { type: String, default: "Семёнов С. С." },
    specName: { type: String, default: "Зубной врач" },
    eventDate: { type: String, default: "09.08.2024" },
    eventTime: { type: String, default: "13:50" },
    number: { type: [String, Number], default: "1" },
  },
  emits: ["go"],
  components: {
    CardLayout,
  },
  setup(props) {
    const router = useRouter();
    const go = () => {
      router.push({
        name: "future-visit-card",
        params: { id: props.number },
      });
    };

    const splitName = computed(() => props.doctorName.split(" "));

    return {
      firstName: computed(() => splitName.value[0]),
      lastName: computed(() => splitName.value[1]),
      secondName: computed(() =>
        splitName.value[2] ? splitName.value[2] : ""
      ),
      go,
    };
  },
};
</script>

<style scoped lang="scss">
.card-doctor {
  &::after {
    content: " ";
    white-space: break-spaces;
  }
}
</style>
